module.exports = __webpack_public_path__ + "static/image3_en-08afc3572c40557bf1786545ee30733f.png";